import { AxiosResponseHeaders } from 'axios';
import { AccountCertificate, AccountCertificateResponseDTO } from '../entities';

const accountCertificateResponseDTOToAccountCertificateAdapter = (
  data: AccountCertificateResponseDTO,
  headers?: AxiosResponseHeaders,
): AccountCertificate => {
  if (!data.body) {
    throw new Error();
  }

  const certificate = data.body;

  return new AccountCertificate(
    certificate.type,
    certificate.file,
    certificate.pdfPages,
    certificate.documentId,
    certificate.filePath,
  );
};

export { accountCertificateResponseDTOToAccountCertificateAdapter };
